// Sandbox config — central flags that turn the floating-obstacle-course
// behaviour on/off. Imported by Game, World, Player. Set once here;
// every system reads from the same source so we can flip behaviour
// without touching ten files.
//
// Default: full sandbox mode.
//   • Levels float above empty space at +floatingLevelBaseY.
//   • Visible meshes are the only collision (no invisible floors / walls
//     / death zones).
//   • Falling off doesn't kill or respawn — gravity takes over and the
//     camera keeps following.

export const SANDBOX_CONFIG = {
  /** When true, off-course = death + outcome event. False = ignored. */
  enableFallDeath: false,
  /** When true, an `unsupportedSince` watchdog respawns the player to
   *  the last checkpoint after a few seconds of free fall. */
  enableAutoRespawnOnFall: true,
  /** When true, a flat invisible plane at low Y catches falling players.
   *  Currently only used for the cosmetic cloud shelf in `World.ts`. */
  enableInvisibleSafetyFloor: false,
  /** When true, a lateral half-width clamp prevents the player from
   *  wandering past the edges of the rendered floor. False = open world. */
  enableInvisibleBoundaryWalls: false,
  /** When true, collision is restricted to actual rendered meshes that
   *  were pushed onto `supportMeshes`. Per-mode "you're standing over a
   *  gap" hand-rolled tests get skipped. */
  visibleObjectsOnlyCollision: true,
  /** Whole-scene Y offset for every visible platform / object. Lifts the
   *  course into the sky so it reads as a floating obstacle course. */
  floatingLevelBaseY: 20,
  /** Debug overlay toggle. F2 in-game also flips it at runtime. */
  debugMode: false,
};

export type SandboxConfig = typeof SANDBOX_CONFIG;
